










import { Component, Vue } from "vue-property-decorator";

import { clearSession } from "../helpers/clear-session";

import EditPassword from "../components/Account/EditPassword.vue";
import DeleteAccount from "../components/Account/DeleteAccount.vue";
import EditEmailAddress from "../components/Account/EditEmailAddress.vue";
import EditUsername from "../components/Account/EditUsername.vue";

@Component({
  components: { EditUsername, EditEmailAddress, EditPassword, DeleteAccount },
})
export default class Main extends Vue {
  logout(): void {
    clearSession();
    this.$router.replace("/login");
  }
}
